import { render } from "./InstanceVolumesStoragePoolSelectListView.vue?vue&type=template&id=601bd2c8&scoped=true"
import script from "./InstanceVolumesStoragePoolSelectListView.vue?vue&type=script&lang=js"
export * from "./InstanceVolumesStoragePoolSelectListView.vue?vue&type=script&lang=js"

import "./InstanceVolumesStoragePoolSelectListView.vue?vue&type=style&index=0&id=601bd2c8&scoped=true&lang=less"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601bd2c8"]])

export default __exports__